import {
  AITaskResponseResultData,
  useLazyGetReviewedPageIssuesQuery,
} from 'api/collaborateApi';
import { useEffect } from 'react';
import { toast } from 'sonner';
import { useAppDispatch } from '../store';
import { setAiTaskData } from '../store/siteInfoSlice';
import useGetPageId from './use-get-pageid';
import useShowAI from './use-show-ai';

const _fakeData = {
  status: 'success',
  message: 'Success',
  result: {
    data: [
      {
        expert: 'Claro',
        element: {
          id: '',
          path: '#header > nav > div > div.hidden.md:flex.items-center.space-x-8 > a:nth-child(1)',
        },
        issueType: 'Overall Impression',
        description:
          "The page successfully reflects a sleek, modern aesthetic that aligns with the brand's established reputation. However, the narrative needs refinement to enhance its strategic depth. The current layout feels like a collection of independent blocks without ",
        badge: 'Strategic Review',
        status: 'pending',
        id: 'N0dJcW1LN004Q2FZZUhjMzhsbVZPQT09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Claro',
        element: {
          id: '',
          path: '#header > nav > div > div.hidden.md:flex.items-center.space-x-8 > a:nth-child(2)',
        },
        issueType: 'Overall Impression',
        description:
          'The overall impression of the page is that it leans heavily into promoting a wide array of products without a cohesive narrative structure. While visually appealing, it lacks a central theme that ties the different sections together, potentially overwhelm',
        badge: 'Strategic Review',
        status: 'pending',
        id: 'ZERLa2E1WlZBanhYMENoalEwY29UZz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Claro',
        element: {
          id: '',
          path: '#header > nav > div > div.hidden.md:flex.items-center.space-x-8 > a:nth-child(3)',
        },
        issueType: 'Overall Impression',
        description:
          'The overall design is visually impactful and aligned with the brand image, but it lacks a cohesive narrative structure. The page feels like a series of isolated promotions rather than a unified experience. To achieve "greatness," we should aim for a seaml',
        badge: 'Strategic Review',
        status: 'pending',
        id: 'Y09NWDBXdHFTa0lEY2grMVdzeVU3Zz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Pixel',
        element: {
          id: 'node-1753797422394-9unerezbg',
          path: '#pricing > div > div.grid.md:grid-cols-3.gap-8.max-w-6xl.mx-auto > div.bg-laravel.text-white.rounded-xl.p-8.transform.scale-105.shadow-xl.relative > div.absolute.-top-4.left-1/2.transform.-translate-x-1/2.bg-yellow-400.text-gray-800.px-4.py-1.rounded-full.text-sm.font-semibold',
        },
        issueType: 'Typography Contrast',
        description:
          "The headline 'Where two leagues collide' could benefit from <strong>better contrast</strong> against the vibrant background to enhance readability.",
        badge: 'Visual Design',
        status: 'pending',
        id: 'bFhibXJGMnlZVUV3cFVleG8wWDNzQT09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Lexi',
        element: {
          id: 'node-1753797422396-rztbrrqok',
          path: '#header > nav > div > div.flex.items-center.space-x-4 > button.bg-laravel.text-white.px-6.py-2.rounded-lg.hover:bg-laravel-dark.transition-all.duration-200.transform.hover:scale-105',
        },
        issueType: 'Clarity',
        description:
          "The copy 'Watch MLS and Liga MX kick off Leagues Cup today' is clear, but lacks a <strong>stronger call to action</strong> to motivate users to engage, such as 'Don't miss it - Watch now!'.",
        badge: 'Content',
        status: 'pending',
        id: 'S2RpNis4T2YyeG5CY3NNNjBTK1U5Zz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Navi',
        element: {
          id: 'node-1753797422392-67i7n5y4z',
          path: 'main[role="main"] > section:first-of-type > div:first-of-type > div > div > a',
        },
        issueType: 'Missing Aria Label',
        description:
          'The link has no accessible name. <strong>Please add an aria-label</strong> for improved screen reader accessibility.',
        badge: 'Accessibility',
        status: 'pending',
        id: 'UVpzTVQwamlyWTFOaFFBUms5MzFndz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Navi',
        element: {
          id: 'node-1753797422396-zv79kyd6o',
          path: 'a[aria-label="Stream\\ now\\,\\ MLS\\ Leagues\\ Cup\\ tab\\ on\\ the\\ Apple\\ TV\\ app"]',
        },
        issueType: 'Link Accessibility',
        description:
          "Consider ensuring the contrast of the 'Stream now' button is <strong>accessible for color-blind users</strong> to avoid exclusion.",
        badge: 'Accessibility',
        status: 'pending',
        id: 'Y0xoVDUwV2FMbitUNStVVEdsK1IxQT09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Lexi',
        element: {
          id: 'node-1753797422405-0cf2vw1ms',
          path: 'main[role="main"] > section:first-of-type > div:nth-of-type(2) > div > div > div:last-of-type > div:first-of-type > div:last-of-type > svg > foreignobject > p',
        },
        issueType: 'Message Strength',
        description:
          "The message 'Choose AirPods or an eligible accessory' is inviting, but could be <strong>strengthened by specifying benefits</strong> like 'Enhance your purchase with free AirPods or other accessories'.",
        badge: 'Content',
        status: 'pending',
        id: 'MHJZOGZXSTFma1Rxa0o0dHNuSFNwZz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Pixel',
        element: {
          id: 'node-1753797422400-yjl23ae45',
          path: 'main[role="main"] > section:first-of-type > div:nth-of-type(2) > div > div > div:last-of-type > div:first-of-type > h2',
        },
        issueType: 'Visual Appeal',
        description:
          'The layout with the educational promotion appears vibrant and engaging, effectively drawing attention to seasonal offers.',
        badge: 'Positive',
        status: 'pending',
        id: 'UjBvLzgwd21GSXBjalZyOFFkeExBdz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Pixel',
        element: {
          id: 'node-1753797424436-u15ndaqnf',
          path: 'main[role="main"] > section:first-of-type > div:last-of-type > div > div > div:first-of-type > h2',
        },
        issueType: 'Typography Imbalance',
        description:
          "The headline 'iPhone' is visually dominant, but the subsequent subhead is too understated and lacks differentiation. <strong>Increase the contrast or size to maintain visual hierarchy</strong>.",
        badge: 'Design',
        status: 'pending',
        id: 'ZVJXT0VYdWFNNFg2VTZqVzFNTnozUT09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Lexi',
        element: {
          id: 'node-1753797424436-9nt4ay7dt',
          path: 'main[role="main"] > section:first-of-type > div:last-of-type > div > div > div:first-of-type > p:first-of-type',
        },
        issueType: 'Weak Messaging',
        description:
          "The text 'Meet the iPhone 16 family.' is quite generic. <strong>Consider adding a unique selling proposition or benefit to make it more compelling</strong>.",
        badge: 'Content',
        status: 'pending',
        id: 'OGo3NDlNKysrdXpuUmNuWjJQWEZBZz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Glitch',
        element: {
          id: 'node-1753797424440-mjot039b0',
          path: 'a[aria-label="Buy\\,\\ iPad\\ Pro"]',
        },
        issueType: 'Link Consistency',
        description:
          "The 'Buy' button link takes users away from the section. <strong>Avoid jarring transitions by handling external links delicately or opening in a new tab</strong>.",
        badge: 'Functionality',
        status: 'pending',
        id: 'NHk0dFdTdXRjbXg0VE1NNkhUcXludz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Index',
        element: {
          id: 'node-1753797424440-wwvpnlzez',
          path: 'a[aria-label="Learn\\ more\\,\\ iPad\\ Pro"]',
        },
        issueType: 'Link Text',
        description:
          "The link text 'Learn more' is too generic and doesn't aid SEO. <strong>Use more descriptive phrases for better search engine visibility</strong>.",
        badge: 'SEO',
        status: 'pending',
        id: 'THk2Znd3aUR1ZXBVM2pNeE4vcmZkdz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Pixel',
        element: {
          id: 'node-1753797424442-24khzphwv',
          path: 'main[role="main"] > section:nth-of-type(2) > div:nth-of-type(2) > div > div > div:first-of-type > h3',
        },
        issueType: 'Visual Flow',
        description:
          "The 'Apple Intelligence' section's header is not visually distinct from subsequent content. <strong>Increase padding or adjust style to guide the user's eye</strong>.",
        badge: 'Design',
        status: 'pending',
        id: 'VmsyVmJNWjZsanVpOXd2eHJ3TVgyUT09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Index',
        element: {
          id: 'node-1753797424437-a9qjhm6je',
          path: 'main[role="main"] > section:first-of-type > div:last-of-type > div > div > div:first-of-type > p:last-of-type > span',
        },
        issueType: 'Semantic Tagging',
        description:
          "The phrase 'Built for Apple Intelligence.' in a span lacks semantic tagging. <strong>Consider using headings or formatted text for better SEO</strong>.",
        badge: 'SEO',
        status: 'pending',
        id: 'Y2c0ZHphNGpFY2VmWTFmZmhvNDhMZz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Pixel',
        element: {
          id: 'node-1753797424436-fhztgwct9',
          path: 'a[aria-label="Learn\\ more\\,\\ iPhone"]',
        },
        issueType: 'Great Design',
        description:
          "<strong>The 'Learn more' button is visually appealing and stands out well against the background.</strong> Good use of contrasting color for the call-to-action.",
        badge: 'Positive',
        status: 'pending',
        id: 'eW5ya1VVN3lmd09zKzRKaG5zMktudz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Claro',
        element: {
          id: '',
          path: '',
        },
        issueType: 'Overall Impression',
        description:
          "The page design demonstrates a clean and modern aesthetic consistent with the brand's identity, which is crucial for maintaining visual credibility. However, the narrative structure lacks clear hierarchy, causing potential confusion about the most importa",
        badge: 'Strategic Review',
        status: 'pending',
        id: 'RENLVGo1aEd2L2x0ZGEvQVFzRllaZz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Pixel',
        element: {
          id: 'node-1753797426459-evsppnvxy',
          path: 'main[role="main"] > section:nth-of-type(2) > div:nth-of-type(2) > div > div > div:first-of-type > p',
        },
        issueType: 'Weak Color Contrast',
        description:
          "The text 'Turn a poster into a Calendar event with visual intelligence' blends into the background. <strong>Enhance the color contrast for better readability and impact.</strong>",
        badge: 'Design',
        status: 'pending',
        id: 'YWtjZndGWHNmTmNBQVkwNHVwNURzQT09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Navi',
        element: {
          id: 'node-1753797426467-czoggic9d',
          path: 'main[role="main"] > section:nth-of-type(2) > div:nth-of-type(4) > div > div > a',
        },
        issueType: 'Missing Label',
        description:
          'The link for the AirPods Pro 2 section lacks an accessible label. <strong>Ensure all interactive elements have accessible names.</strong>',
        badge: 'Accessibility',
        status: 'pending',
        id: 'NmR3SWhENnpzZURFU1RKeTlTdGM4QT09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Lexi',
        element: {
          id: 'node-1753797426462-5iizety9v',
          path: 'main[role="main"] > section:nth-of-type(2) > div:nth-of-type(3) > div > div > div:first-of-type > div:first-of-type > p',
        },
        issueType: 'Vague Copy',
        description:
          "The description 'Sky blue color. Sky high performance with M4.' feels generic. <strong>Refine with distinct benefits or features to better persuade potential buyers.</strong>",
        badge: 'Content',
        status: 'pending',
        id: 'UmwwZ0FncEdIaExNSmtXVENnVWxnZz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Glitch',
        element: {
          id: 'node-1753797426463-arrhrqp5w',
          path: 'a[aria-label="Buy\\,\\ Macbook\\ Air\\ with\\ M4\\ chip"]',
        },
        issueType: 'Link Accessibility',
        description:
          'The buy links do not explain destination or process. <strong>Add relevant aria-labels to improve navigation for assistive technologies.</strong>',
        badge: 'Functionality',
        status: 'pending',
        id: 'UG9uLzRuZUpDcWFsZHR6OVlxcnR6UT09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Index',
        element: {
          id: 'node-1753797426479-80mk8mrtp',
          path: 'main[role="main"] > section:nth-of-type(2) > div:last-of-type > div > div > div:first-of-type > p',
        },
        issueType: 'Keyword Optimization',
        description:
          "The sentence 'Get up to 3% Daily Cash back with every purchase.' lacks SEO optimization. <strong>Consider incorporating keywords like 'Apple Card cashback benefits.'</strong>",
        badge: 'SEO/Structure',
        status: 'pending',
        id: 'aGM3TmpRZldYbCtYS0UwL1pJTytSQT09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Pixel',
        element: {
          id: 'node-1753797426468-082ltfljw',
          path: 'main[role="main"] > section:nth-of-type(2) > div:nth-of-type(4) > div > div > div:first-of-type > h3',
        },
        issueType: 'Strong Visual Impact',
        description:
          'The AirPods Pro 2 section with headline and image creates a visually strong call-to-action. <strong>Excellent use of imagery and typography to capture attention.</strong>',
        badge: 'Positive',
        status: 'pending',
        id: 'TkRtMGp3N0hLSXUzM2VseVNMUVlIUT09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Pixel',
        element: {
          id: 'node-1753797429060-vqw7by2pc',
          path: 'main[role="main"] > section:nth-of-type(3) > div > div[aria-label="Tv\\ Plus\\ Gallery"] > div:last-of-type > div > ul[role="tablist"] > li[role="presentation"] > a[aria-label="item\\ 4\\ -\\ shrinking"] > span',
        },
        issueType: 'Visual Hierarchy',
        description:
          'The carousel feature for Apple TV+ lacks proper visual hierarchy. <strong>Items do not stand out clearly </strong>and users might find it difficult to focus on particular content. Consider enhancing the focus on highlighted items.',
        badge: 'Design',
        status: 'pending',
        id: 'ZXo5dHg4Mm5TL0Q4cW83bmRpUnBwZz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Navi',
        element: {
          id: 'node-1753797429057-fuf6vp8qg',
          path: 'main[role="main"] > section:nth-of-type(3) > div > div[aria-label="Tv\\ Plus\\ Gallery"] > div:last-of-type > div > ul[role="tablist"] > li[role="presentation"] > a[aria-label="item\\ 2\\ -\\ the\\ studio"] > span',
        },
        issueType: 'Missing Accessible Text',
        description:
          'The span elements serving as carousel items do not clearly convey their purpose to screen readers. <strong>Aria-labels should be more descriptive</strong> to improve accessibility.',
        badge: 'Accessibility',
        status: 'pending',
        id: 'SlpwN21PMWIrVU9JNXFXMXJRQWpBdz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Index',
        element: {
          id: 'node-1753797429055-bftqc59yk',
          path: 'main[role="main"] > section:nth-of-type(3) > div > div[aria-label="Tv\\ Plus\\ Gallery"] > h3',
        },
        issueType: 'SEO Header Structure',
        description:
          'The visually hidden H3 labeling Apple TV+ impacts discoverability. <strong>Ensure headers are strategically placed and visible</strong> to effectively support SEO and content structure.',
        badge: 'SEO',
        status: 'pending',
        id: 'b0llK2FVMEs5OGpjTXdDVFlzdTJ4dz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Lexi',
        element: {
          id: 'node-1753797429111-x1g25zctm',
          path: 'main[role="main"] > section:last-of-type > div > div[aria-label="Gallery\\ of\\ Apple\\ services\\,\\ including\\ Fitness\\ Plus\\,\\ Apple\\ Arcade\\,\\ and\\ Apple\\ Music"] > div > div:nth-of-type(8) > a > div:last-of-type > p',
        },
        issueType: 'Content Relevance',
        description:
          "The content 'Seth Rogen: The Zane Lowe Interview' may not engage the corporate audience effectively. <strong>Reevaluate this for alignment with professional interests</strong>.",
        badge: 'Content',
        status: 'pending',
        id: 'ZXdUWkZiek9iTVNJN2xlNEJYT3ZrUT09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Glitch',
        element: {
          id: 'node-1753797429071-ap45cl0cm',
          path: 'main[role="main"] > section:last-of-type > div > div[aria-label="Gallery\\ of\\ Apple\\ services\\,\\ including\\ Fitness\\ Plus\\,\\ Apple\\ Arcade\\,\\ and\\ Apple\\ Music"] > div > div:first-of-type > a',
        },
        issueType: 'Broken Link',
        description:
          "The link appears accessible but offers no clear functionality. <strong>Check and verify the link functionality</strong> to ensure it's directing users to the intended content.",
        badge: 'Functionality',
        status: 'pending',
        id: 'WkFlNHU0QU5vNjVCU2hsWWpFeFcxQT09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Pixel',
        element: {
          id: 'node-1753797429073-3mx5f5uhb',
          path: 'main[role="main"] > section:last-of-type > div > div[aria-label="Gallery\\ of\\ Apple\\ services\\,\\ including\\ Fitness\\ Plus\\,\\ Apple\\ Arcade\\,\\ and\\ Apple\\ Music"] > div > div:first-of-type > a > div:last-of-type',
        },
        issueType: 'Great Visuals',
        description:
          "The visuals for 'Gallery of Apple Services' are vibrant and engaging, successfully drawing attention to promoted services. <strong>Great use of color and imagery</strong> to highlight offerings.",
        badge: 'Positive',
        status: 'pending',
        id: 'WWYvWWVyMGk3RFZGejA0RXZQQ2lrQT09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Lexi',
        element: {
          id: 'node-1753797431157-79ykdmltk',
          path: 'main[role="main"] > section:last-of-type > div > div[aria-label="Gallery\\ of\\ Apple\\ services\\,\\ including\\ Fitness\\ Plus\\,\\ Apple\\ Arcade\\,\\ and\\ Apple\\ Music"] > div > div:first-of-type > a',
        },
        issueType: 'Ambiguous Hyperlink',
        description:
          "The link text 'here' is vague and does not inform the user about its destination. Consider providing more descriptive anchor text.",
        badge: 'Content',
        status: 'pending',
        id: 'bTQ0OFF3a2dRM3F3M2VlMUtNbHp2Zz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Navi',
        element: {
          id: 'node-1753797431258-hb92pmjg5',
          path: 'footer[role="contentinfo"] > div > section:last-of-type > div:last-of-type > ul[role="list"] > li[role="listitem"] > a',
        },
        issueType: 'Contrast Issue',
        description:
          "**Text contrast** is low, making it difficult for users with visual impairments to read the 'Privacy Policy' text. Enhance contrast between text and background.",
        badge: 'Accessibility',
        status: 'pending',
        id: 'UTZxek1DdzNUOGM0QUNRRVNrQVQyUT09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Glitch',
        element: {
          id: 'node-1753797431256-irem7ixuy',
          path: 'footer[role="contentinfo"] > div > section:last-of-type > div:first-of-type > a:first-of-type',
        },
        issueType: 'Link Functionality',
        description:
          "The 'Find an Apple Store' link is non-functional in the current viewport. Ensure the link directs to the intended page.",
        badge: 'Functionality',
        status: 'pending',
        id: 'SUorSW05YUF6UDV0UGprdWs4SzRKZz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Lexi',
        element: {
          id: 'node-1753797431187-w3j6citeg',
          path: 'footer[role="contentinfo"] > div > section[aria-label="Footnotes"] > ul > li:first-of-type > span > a',
        },
        issueType: 'Footnote Presentation',
        description:
          'Footnotes are presented with small text that may reduce readability. Consider using a larger font size for enhanced readability.',
        badge: 'Content',
        status: 'pending',
        id: 'eFRxU28zOCtVR2duUVlmcTc2MThrdz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Navi',
        element: {
          id: 'node-1753797431226-7qlalh5sn',
          path: 'footer[role="contentinfo"] > div > nav[aria-label="Apple\\ Directory"] > div:nth-of-type(3) > div > ul[role="list"] > li[role="listitem"] > a',
        },
        issueType: 'Navigation Overload',
        description:
          "The current slice's navigation options are dense, potentially overwhelming users. Consider organizing links into expandable sections for a cleaner experience.",
        badge: 'UX',
        status: 'pending',
        id: 'MXhXcHNncjBSODRjbllRKzdsY1RJQT09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Index',
        element: {
          id: 'node-1753797431256-idtq5wy27',
          path: 'footer[role="contentinfo"] > div > section:last-of-type > div:first-of-type > a:last-of-type',
        },
        issueType: 'Link Redundancy',
        description:
          'There is a repeated focus on directing users to an external site without context or value addition. Evaluate the necessity of such links in the footer.',
        badge: 'SEO',
        status: 'pending',
        id: 'WXF2MW9HOWtRQ0ltakptTUdrTTk1Zz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Navi',
        element: {
          id: 'node-1753797431205-d3kgwf3cb',
          path: 'footer[role="contentinfo"] > div > nav[aria-label="Apple\\ Directory"] > div:first-of-type > div:last-of-type > ul[role="list"] > li[role="listitem"] > a',
        },
        issueType: 'Aria-label Absence',
        description:
          "The 'Apple Cash' link lacks an 'aria-label', which hinders screen-reader users. Add a descriptive 'aria-label'.",
        badge: 'Accessibility',
        status: 'pending',
        id: 'QVRHakpPSnRHK3RlMStER1VXSjF2Zz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Pixel',
        element: {
          id: '',
          path: '',
        },
        issueType: 'Visual Clarity Enhancement',
        description:
          '**Overall visual layout** is clean but could benefit from increased spacing between sections to improve visual separation and user focus.',
        badge: 'Design',
        status: 'pending',
        id: 'OWdGeFJGV3dwcGhTVHcyNXJDc2ZvUT09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Navi',
        element: {
          id: 'node-1753797431196-1h3wwns6t',
          path: 'footer[role="contentinfo"] > div > nav[aria-label="Apple\\ Directory"] > div:first-of-type > div:first-of-type > ul[role="list"] > li[role="listitem"] > a',
        },
        issueType: 'Link Identification',
        description:
          'Links are indistinguishable from regular text due to lack of underline or other visual cue when not hovered. Improve visual distinction for accessibility.',
        badge: 'Accessibility',
        status: 'pending',
        id: 'TFNkNm1ocCtodXFvQTZTNVZSbjk2dz09',
        taskId: null,
        task: null,
      },
      {
        expert: 'Pixel',
        element: {
          id: '',
          path: '',
        },
        issueType: 'Footer Content',
        description:
          'The footer is well-organized, providing a comprehensive directory for users to navigate various services effectively.',
        badge: 'Positive',
        status: 'pending',
        id: 'b01wbW1IZldQSlpJbjA3TkZLRFJNdz09',
        taskId: null,
        task: null,
      },
    ],
  },
};

export const useAiReviewTasks = () => {
  const dispatch = useAppDispatch();
  const showAI = useShowAI();
  const { pageId } = useGetPageId();
  const debug = false;
  const [fetch, { isFetching }] = useLazyGetReviewedPageIssuesQuery();

  useEffect(() => {
    if (!showAI || debug) return;
    const handleFetchReviewedIssues = async () => {
      if (!pageId) return;
      try {
        if (!pageId) {
          console.error('Page ID is not available.');
          toast.error(
            'Page ID is not available. Please select a page to review.'
          );
          return;
        }

        const reviewedIssues = await fetch(
          {
            pageId,
            status: 'pending',
          },
          true
        ).unwrap();
        dispatch(setAiTaskData(reviewedIssues));
      } catch (error) {
        console.error('Review failed:', error);
      }
    };
    handleFetchReviewedIssues();
  }, [pageId, fetch, dispatch, showAI, debug]);

  // for testing
  useEffect(() => {
    if (!debug) return;
    dispatch(
      setAiTaskData(
        _fakeData.result.data as unknown as AITaskResponseResultData[]
      )
    );
  }, [dispatch, debug]);

  return {
    isFetching,
  };
};
